import { useCallback, useState } from 'react';
import { httpPut } from '../../../../components/utils';

const useUpdateStaleAccessByResourceId = (onSuccessCallback) => {
    const reqUrl = `/accessAnalysis/resources/stale-access`;
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const updateStaleAccessMutation = useCallback(
        async (data) => {
            const params = {
                resource_id: data.resource_id,
                stale_access_since: data.stale_access_since
            };
            setIsError(false);
            setIsLoading(true);
            try {
                await httpPut(reqUrl, params);
                onSuccessCallback(data.resource_id, data.stale_access_since);
            } catch (e) {
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        },
        [onSuccessCallback]
    );

    return { updateStaleAccessMutation, isLoading, isError };
};

export default useUpdateStaleAccessByResourceId;
